import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardWithoutMedia = ({
    plus,
    text,
    title,
	classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="d-flex align-items-baseline">
			<div className="content-header col-2 align-items-baseline p-0">
				<p>{plus}</p>
			</div>
			<div className="col-10 p-0">
				<p className="title">
					{title}
				</p>
				<span>
					{text}
				</span>
			</div>
		</div>
	</StyledCard>
);

PropTypes.Card = {
	icon: PropTypes.element,
	altIcon: PropTypes.string,
	titleIcon: PropTypes.string,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default CardWithoutMedia;
